import { render, staticRenderFns } from "./EditReceiveForm.vue?vue&type=template&id=19348b10"
import script from "./EditReceiveForm.vue?vue&type=script&lang=js"
export * from "./EditReceiveForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports